let instance = null;

export class refreshTokenProvider {

    constructor() {
        if (instance === null) {
            this.refreshTokenPromise = null;
            instance = this;
        }
        return instance;
    }

    setRefreshTokenPromise(promise) {
        this.refreshTokenPromise = promise;
        const curriedClearRefreshPromiseFn = this.clearRefreshTokenPromise.bind(this);
        this.refreshTokenPromise.then(curriedClearRefreshPromiseFn, curriedClearRefreshPromiseFn);
    }

    getRefreshTokenPromise() {
        return this.refreshTokenPromise;
    }

    clearRefreshTokenPromise() {
        this.refreshTokenPromise = null;
    }

    waitPromiseDone() {
        return new Promise((resolve) => {
            this.refreshTokenPromise.then(() => resolve(true));
        });
    }
}